import * as React from "react";
import { styled } from "@mui/material";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const base = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 1552 1411",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			x: 1334.48,
			y: 292.854,
			width: 301.341,
			height: 1244.9,
			transform: "rotate(44.0606 1334.48 292.854)",
			fill: "url(#paint0_linear_10372_10568)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 1142.62,
			width: 330.836,
			height: 1643.07,
			transform: "rotate(44.0606 1142.62 0)",
			fill: "url(#paint1_linear_10372_10568)"
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [/* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint0_linear_10372_10568",
			x1: 1485.15,
			y1: 292.854,
			x2: 1485.15,
			y2: 1537.75,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", {
				stopColor: "#FFF4E0",
				stopOpacity: .2
			}), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#FFF4E0",
				stopOpacity: .1
			})]
		}), /* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint1_linear_10372_10568",
			x1: 1308.04,
			y1: 0,
			x2: 1308.04,
			y2: 1643.07,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", {
				stopColor: "#FFF4E0",
				stopOpacity: .2
			}), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#FFF4E0",
				stopOpacity: .1
			})]
		})] })
	]
});
const SvgRays = styled(base)({});
export default SvgRays;
